import { Injectable } from '@angular/core';
import {
  buildChatGroupKey,
  closeNotificationsByGroup,
} from '../../../firebase-messaging/message-handler';

@Injectable({ providedIn: 'root' })
export class ChatNotificationDismissalService {
  async closeChannelNotifications(channelId: string): Promise<void> {
    if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
    const registration = await navigator.serviceWorker.ready;
    await closeNotificationsByGroup(registration, buildChatGroupKey(channelId));
  }
}
